import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { finalize, shareReplay } from "rxjs/operators";
import { AuthFacade } from "src/app/store/auth/facade/auth.facade";
import { BaseHttpService } from "./base.http.service";

@Injectable({
    providedIn: 'root'
})
export class CachedHttpObservableService extends BaseHttpService {
    private cachedObservables = {};
    private isUserLoggedIn: Subscription;

    constructor(private authFacade: AuthFacade) {
        super();

        this.isUserLoggedIn = this.authFacade.userLoggedIn$()
            .subscribe((isUserLoggedIn: boolean) => {
                if (!isUserLoggedIn) {
                    this.cachedObservables = {};
                }
            });
    }

    // ONLY USE IF ABSOLUTELY NEEDED.
    // A better approach to handling duplicate API calls may be found in deduplicatingSwitchMap.ts
    // Temporarily caches http requests if multiple duplicate requests are made before the first request completes.
    public getCachedHttpGetObservable<T>(url: string, http: HttpClient) {
        let observable: Observable<T>;

        if (this.cachedObservables[url]) {
            observable = this.cachedObservables[url];
        } else {
            // Execute http request and cache the observable.
            this.cachedObservables[url] = http.get(url, {
                observe: 'body',
                responseType: 'json',
                headers: this.getHttpHeaders()
            }).pipe(
                finalize(() => {

                  // Observable is complete so null it to wipe it from the cache.
                  this.cachedObservables[url] = null;
                }),
                // Multicast this observable to multiple subscribers using shareReplay().
                // shareReplay() 'shares' this observable to all subscribers (one-to-many) and notifies them all when the http request is complete.
                //
                // IMPORTANT: shareReply() needs to be below the finalize() operator to ensure finalize() is called AFTER all subscribers have been notified.
                // Otherwise the observable will null itself before all subscribers are notified.
                //
                // bufferSize: 1 means that only the last value is cached. Should only be 1 value but adding just in case.
                // refCount: true means that the observable will complete (and clears cached replay) when all subscribers have been notified.
              shareReplay({ bufferSize: 1, refCount: true }),
            );

            observable = this.cachedObservables[url];
        }

        return observable;
    }
}